import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  min-width: 1060px;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Title = styled.div`
  display: flex;
  padding: 24px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const TabSection = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--alias-color-line-normal);
  height: 40px;
  box-sizing: border-box;
`;

export const TabBar = styled.div`
  display: flex;
  padding: 0px 24px;
  align-items: flex-end;
  gap: 20px;
  flex: 1 0 0;
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  border-bottom: 2px solid ${(props) => (props.selected ? "var(--alias-color-primary-normal)" : "transparent")};

  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: 0.16px;
  text-align: center;
  color: ${(props) => (props.selected ? "var(--alias-color-primary-normal)" : "var(--alias-color-label-alternative)")};
`;
